import React, { useEffect, useRef, useState }                               from 'react';
import { Modal, Form, Button }                                              from 'react-bootstrap';
import { useDispatch }                                                      from 'react-redux';
import Select                                                               from 'react-select';
import { Formik }                                                           from 'formik';
import moment                                                               from 'moment';
import * as yup                                                             from 'yup';

import { AUDIENCIA_GROUP }                                                  from '../../../../../data/resultTypeGroups';
import { EFECTIVA, RECONVERTIDA, CONTINUIDAD, REPROGRAMADA, SUSPENDIDA }    from '../../../../../data/audienceStates';
import { ErrorMessage }                                                     from '../../../../extras/toastMessages';
import { finalizeAudienceAction }                                           from '../../../../../actions/audiencesActions';
import { ICON_CANCEL, ICON_FINALIZE }                                       from '../../../../extras/icons';
import { MSG_ERROR_SERVER }                                                 from '../../../../../constants/messages';
import { MOTIVO_SUSPENSION }                                                from '../../../../../data/audienceMotivesGroups';

import AccusedsList                                                         from '../AccusedsList';
import ButtonSpinner                                                        from '../../../../layout/ButtonSpinner'
import clienteAxios                                                         from '../../../../../config/axios';




const ResultsForm = props => {



    // --------------------------------------------------------------------------------------------
    // DECLARACIONES ------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Tomo los props
    const { show, handleClose, audience } = props;

    // Genero los ref
    const refInicioReal = useRef();

    // Inicializo datos
    const initialData = {
        estado: '',
        fecha: moment( new Date(audience.inicio) ).format("YYYY-MM-DD"),
        horaInicioReal: audience.inicioReal === null ? "" : moment( new Date(audience.inicioReal) ).format("hh:mm:ss"),
        horaFinReal: audience.inicioReal === null ? "" : moment( new Date(audience.finReal) ).format("hh:mm:ss"),
        motivos: {},
        observacion: audience.observacion || '',
        resultados: [],
        tipos: []
    }

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Inicializo el state local
    const [enabledResultTypes, setEnabledResultTypes] = useState([]);
    const [formData, setFormData] = useState(initialData);
    const [loading, setLoading] = useState(false);
    const [motivos, setMotivos] = useState([]);
    const [motives, setMotives] = useState([]);
    const [resultados, setResultados] = useState([]);
    const [resultTypes, setResultTypes] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [types, setTypes] = useState([]);


    // --------------------------------------------------------------------------------------------
    // FUNCIONES ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Carga Inicial de los Resultados
    useEffect(() => {
        if(audience?.resultadoList)
        {   const auxResultados = audience.resultadoList?.map(res=>({
                id: res.id,
                label: res.descripcion,
                value: res.id,
            })) || [];
            setFormData({
                ...formData,
                resultados: auxResultados
            })
            setResultados(auxResultados);
        }
        // Refresca cuando cierro el formulario y el estado era RECONVERTIDA
        if(!show && parseInt(formData?.estado || 0)===RECONVERTIDA)
            window.location.reload();
        // eslint-disable-next-line
    }, [audience, show])

    // Manejo los cambios en los Tipos
    useEffect(() => {
        if(typeof tipos!=="undefined" && typeof resultTypes.content!=="undefined")
        {   //Tomo los tipos de audiencia seleccionados
            const audienceTypes = resultTypes.content.filter(r => tipos.find(t => t.id === r.id));
            //Recargo los resultados
            loadResultTypes(audienceTypes);
        }
        //eslint-disable-next-line
    }, [tipos]);

    // Manejo el cambio de estado
    const handleChangeEstado = (e, values) => {
        //Seteo la data del formulario
        setFormData({
            ...values,
            estado: e.target.value
        });
        //Si cambia, recargo los resultados
        loadResultTypes(audience.audienciaTipoList);
    }

    // Manejo cambio del select
    const handleChangeMotivos = (options,values,_e) => {
        //Seteo los motivos
        setMotivos({    value: options.value,
                        label: options.label
                    })
        //Seteo la data
        setFormData({
            ...values,
            motivos: {  id: options.value,
                        descripcion: options.label
                     }
        })
    }

    // Manejo cambio del select
    const handleChangeResultados = (options, values, _e) => {
        //Seteo los datos
        setResultados(options?.map(option => (
            {   id: option.value,
                label: option.label,
                value: option.value,
            }
        )) || [])
        //Seteo data
        setFormData({
            ...values,
            resultados: options?.map(option => (
                {   id: option.value,
                }
            )) || []
        })
    }

    // Manejo cambio del select
    const handleChangeTipos = (options,values,_e) => {
        //Seteo los datos
        setTipos( options ? options.map(option => (
                {   id: option.value,
                    label: option.label,
                    value: option.value,
                }
        )) : [])
        //Seteo la data
        setFormData({
            ...values,
            tipos: options ? options.map(option => (
                {   id: option.value,
                }
            )) : []
        })
    }

    // Manejo el cierre
    const handleCloseForm = () => {
        //Limpio los datos
        setFormData(initialData);
        //Cierro el form
        handleClose();
    }

    // Manejo cuando se muestra
    const handleOnShow = e => {
        //Cargo los parámetros
        loadParameters();
        //Pongo el foco en el primer campo
        refInicioReal.current.focus();
    }    

    // Manejo el guardado
    const handleSave = values => {
        //Armo los datos
        let data = {
            audienciaId: audience.id,
            estadoId: values.estado,
            finReal: moment(new Date(`${initialData.fecha.toString()} ${values.horaFinReal.toString()}`)).format('YYYY-MM-DD k:mm:ss'),
            inicioReal: moment(new Date(`${initialData.fecha.toString()} ${values.horaInicioReal.toString()}`)).format('YYYY-MM-DD k:mm:ss'),
            observacion: values.observacion,
            resultados
        }
        //Me fijo si debo agregar los tipos
        if(parseInt(values.estado) === RECONVERTIDA)
        {   //Inicializo tipos
            data = {
                ...data,
                tipos
            }
        }
        //Me fijo si debo agregar los motivos
        if(parseInt(values.estado) === SUSPENDIDA)
        {   //Inicializo tipos
            data = {
                ...data,
                motivo : {
                    id: motivos.value,
                    descripcion: motivos.label
                }
            }
        }
        //Llamo al dispatch
        dispatch( finalizeAudienceAction(data, handleClose) );
    }

    // Función que cargar los motivos
    const loadParameters = async () => {
        try
        {   //Cargo la espsera
            setLoading(true);

            //TIPOS --------------------------------------------------------------
            //Cargo los resultados posibles para el tipo de audiencia seleccionado
            loadResultTypes(audience.audienciaTipoList);
            //Hago la consulta
            const responseTypes = await clienteAxios.get(`/audiencia-tipo?search=activo:1&sort=descripcion:asc`);
            //Obtengo los datos
            const resultTypes = responseTypes.data;
            //Los guardo
            setResultTypes(resultTypes);
            //Seteo los datos
            setTypes(resultTypes.content);

            //MOTIVOS --------------------------------------------------------------
            //Hago la consulta
            const responseMotives = await clienteAxios.get(`/motivo?search=activo:1&sort=descripcion:asc`);
            //Obtengo los datos
            const resultMotives = responseMotives.data;
            //Seteo los datos
            const content = resultMotives.content.filter( item=>item.grupo.descripcion===MOTIVO_SUSPENSION );
            //Los guardo
            setMotives(content);

            //Oculto la espera
            setLoading(false);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Oculto la espera
            setLoading(false);
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }

    // Función para cargar el tipo de resultados
    const loadResultTypes = async audienceTypes => {
        try
        {   //Marco la espera si no está cargada
            if(!loading)
            {   setLoading(true);
            }
            //Hago la consulta
            const responseResults = await clienteAxios.get(`/resultado?search=tipo:${AUDIENCIA_GROUP},activo:1&sort=descripcion:asc`);
            //Obtengo los datos
            const resultResults = responseResults.data;
            //Inicializo los resultados posibles
            let enabledResults = [];
            //Busco los resultados posibles en base a los tipos de audiencia
            audienceTypes.forEach(type => {
                type.resultadoList.forEach(result => {
                    enabledResults = [
                        ...enabledResults,
                        result
                    ]
                })
            })
            //Filtro los resultados posibles
            const resultResultsOk = resultResults.content.filter(resultType => enabledResults.find(r => r.id === resultType.id));
            //Llamo al dispatch
            setEnabledResultTypes(resultResultsOk);
            //Oculto espesta
            setLoading(false);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Oculto la espera
            setLoading(false);
            //Mensaje de error
            ErrorMessage(data.message);
        }
    } 
    
    // Este método me sirve para saber si necesito mostrar y validar resultados
    const resultRequired = estadoValue => {
        return (parseInt(estadoValue) !== REPROGRAMADA && parseInt(estadoValue) !== SUSPENDIDA && parseInt(estadoValue) !== CONTINUIDAD) ? true : false
    }

    // Esquema de validación
    const validationSchema = yup.object({
        estado: yup.number().required(),
        horaFinReal: yup.string().typeError('Ingrese un horario válido').required('Ingrese un horario válido')
        .test("is-greater", "La hora de finalización debe ser posterior a la de inicio", function(value) {
            const { horaInicioReal } = this.parent;
            return moment(value, "HH:mm").isAfter(moment(horaInicioReal, "HH:mm"));
        }),
        horaInicioReal: yup.string().typeError('Ingrese un horario válido').required('Ingrese un horario válido'),  
        motivos: yup.object().nullable().when('estado', {
            is: SUSPENDIDA,
            then: yup.object().required()
        }),      
        observacion: yup.string().nullable(),
        resultados: yup.array().when('estado',(estado)=>{
            if(resultRequired(estado))
                return yup.array().required();
        }),
        tipos: yup.array().nullable().when('estado', {
            is: RECONVERTIDA,
            then: yup.array().required()
        })
    });  
    
    

    // --------------------------------------------------------------------------------------------
    // RENDERIZO ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    return (
        <Modal 
            show = { show } 
            onHide = { handleCloseForm } 
            onShow = { handleOnShow } 
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            size = "lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Resultados <strong><small>Audiencia #{ audience.id }</small></strong>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema = { validationSchema }
                initialValues = {{ ...formData }}
                onSubmit = { values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    values,
                    errors,
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Indique el estado de finalización y el/los resultados de la misma.
                                    </div>
                                </div>
                                <Form.Group className="col-md-4">
                                    <label htmlFor="fecha">Fecha</label>
                                    <Form.Control
                                        id = "fecha"
                                        className = "form-control" 
                                        autoFocus 
                                        name = "fecha" 
                                        type = "date" 
                                        placeholder = "Ingrese Fecha"
                                        value = { values.fecha }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.fecha }
                                        disabled
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fecha }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <label htmlFor="horaInicioReal">Inicio real</label>
                                    <Form.Control
                                        id = "horaInicioReal"
                                        className = "form-control" 
                                        autoFocus 
                                        name = "horaInicioReal" 
                                        type = "time" 
                                        placeholder = "Ingrese Hora de inicio"
                                        step = "1"
                                        value = { values.horaInicioReal }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.horaInicioReal }
                                        disabled = { loading }
                                        ref = { refInicioReal }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.horaInicioReal }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <label htmlFor="horaFinReal">Fin real</label>
                                    <Form.Control
                                        id = "horaFinReal"
                                        className = "form-control" 
                                        name = "horaFinReal" 
                                        type = "time" 
                                        placeholder = "Ingrese hora de finalización"
                                        step = "1"
                                        value = { values.horaFinReal }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.horaFinReal }
                                        disabled = { loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.horaFinReal }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <label htmlFor="estado">Estado</label>
                                    <Form.Control
                                        as = "select"
                                        id = "estado"
                                        className = "form-control"  
                                        name = "estado" 
                                        value = { values.estado }
                                        onChange = { e=>handleChangeEstado(e,values) }
                                        isInvalid = { !!errors.estado }
                                        disabled = { loading }
                                    >
                                        <option value="">Seleccione...</option>
                                        <option value={ EFECTIVA }>EFECTIVA</option>
                                        <option value={ RECONVERTIDA }>RECONVERTIDA</option>
                                        <option value={ CONTINUIDAD }>CONTINUIDAD</option>
                                        <option value={ REPROGRAMADA }>REPROGRAMADA</option>
                                        <option value={ SUSPENDIDA }>SUSPENDIDA</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.estado }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-8">
                                    <label htmlFor="observacion">Observaciones</label>
                                    <Form.Control
                                        id = "observacion"
                                        className = "form-control" 
                                        name = "observacion" 
                                        type = "text" 
                                        placeholder = "Ingrese observación"
                                        value = { values.observacion }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.observacion }
                                        disabled = { loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.observacion }
                                    </Form.Control.Feedback>
                                </Form.Group>

                                {   // ESTADO = RECONVERTIDA
                                    values.estado && parseInt(values.estado) === RECONVERTIDA &&
                                        <Form.Group className="col-md-12">
                                            <label htmlFor="tipos">Tipo/s de Audiencia</label>
                                            <Select
                                                name = "tipos"
                                                onChange = { (options,e)=>handleChangeTipos(options, values, e) }
                                                isMulti
                                                noOptionsMessage = { ()=>("No se encontraron datos") }
                                                placeholder = "Seleccione"
                                                className = { !!errors.tipos ? `is-invalid` : '' }
                                                value = { tipos }
                                                options = { types?.map(type => (
                                                    {   value: type.id,
                                                        label: type.descripcion
                                                    }
                                                )) }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                { errors.tipos }
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                }

                                {   // RESULTADOS = EFECTIVA / RECONVERTIDA
                                    resultRequired(values.estado) &&
                                        <Form.Group className="col-md-12">
                                            <label htmlFor="resultados">Resultados</label>
                                            <Select
                                                name = "resultados"
                                                onChange = { (options,e)=>handleChangeResultados(options, values ,e) }
                                                isMulti
                                                noOptionsMessage = { ()=>("No se encontraron datos") }
                                                placeholder = "Seleccione"
                                                value = { resultados }
                                                className = { !!errors.resultados ? `is-invalid` : '' }
                                                options = { enabledResultTypes?.map(resultType => (
                                                    {   value: resultType.id,
                                                        label: resultType.descripcion
                                                    }
                                                )) }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                { errors.resultados }
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                }

                                {   // ESTADO = RECONVERTIDA -> Muestra Tabla Imputados
                                    values.estado && parseInt(values.estado) === RECONVERTIDA &&
                                        <AccusedsList
                                            audience = { audience }
                                            resultForm
                                            tipos = { tipos }
                                        />  
                                }

                                {   // ESTADO = SUSPENDIDA
                                    values.estado && parseInt(values.estado) === SUSPENDIDA &&
                                        <Form.Group className="col-md-12">
                                            <label htmlFor="motivos">Motivo de Suspensión</label>
                                            <Select
                                                className = { !!errors.motivos ? `is-invalid` : '' }
                                                name = "motivos"
                                                noOptionsMessage = { ()=>("No se encontraron datos") }
                                                onChange = { (options,e)=>handleChangeMotivos(options, values, e) }
                                                placeholder = "Seleccione"
                                                value = { motivos }
                                                options = { motives?.map( motive=>(
                                                    {   value: motive.id,
                                                        label: motive.descripcion
                                                    }
                                                )) }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                { errors.motivos }
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                }

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {   loading 
                                    ?
                                        <ButtonSpinner />
                                    :
                                        <Button variant="success" type="submit" disabled={loading}>
                                            <ICON_FINALIZE /> <strong>FINALIZAR AUDIENCIA</strong>
                                        </Button>
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={loading}>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default ResultsForm;